<template>
  <HeaderApp />
  <div class="mt-14"></div>

  <div
    id="printDev"
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      (isHide
        ? '  '
        : $store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <InvoiceHeader
      invoice_type="debt_discount_report"
      v-if="isHide == true"
    />

    <!-- Header -->
    <div
      class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between flex-wrap gap-4"
    >
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("debt_discount_report") }}
      </h1>
      <button
        class="my_font bg-primaryColor hover:bg-blue-700 text-white font-bold py-1 px-4 rounded no-print"
        @click="printReportFunc"
        v-if="$store.getters['checkPrintAccess']"
      >
        {{ $t("print") }}
      </button>
    </div>

    <!-- Filters -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 no-print">
      <div
        class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-4 gap-y-2"
      >
        <div>
          <label
            class="block mb-2 text-sm text-textBlack1 dark:text-textWhite1"
          >
            {{ $t("start_date") }}
          </label>
          <input
            type="date"
            class="bg-white border text-sm border-gray-300 rounded-lg block w-full p-2 dark:bg-bgFullDark dark:border-gray-600 dark:text-white"
            v-model="startDate"
            @change="onFilterChanged"
          />
        </div>
        <div>
          <label
            class="block mb-2 text-sm text-textBlack1 dark:text-textWhite1"
          >
            {{ $t("end_date") }}
          </label>
          <input
            type="date"
            class="bg-white border text-sm border-gray-300 rounded-lg block w-full p-2 dark:bg-bgFullDark dark:border-gray-600 dark:text-white"
            v-model="endDate"
            @change="onFilterChanged"
          />
        </div>
        <div>
          <label
            class="block mb-2 text-sm text-textBlack1 dark:text-textWhite1"
          >
            {{ $t("choose_period") }}
          </label>
          <select
            class="bg-white border border-gray-300 text-sm rounded-lg block w-full p-2 dark:bg-bgFullDark dark:border-gray-600 dark:text-white"
            v-model="period"
            @change="onPeriodChanged"
          >
            <option value="today" class="my_font">{{ $t("today") }}</option>
            <option value="yesterday" class="my_font">
              {{ $t("yesterday") }}
            </option>
            <option value="last7days" class="my_font">
              {{ $t("last7days") }}
            </option>
            <option value="last30days" class="my_font">
              {{ $t("last30days") }}
            </option>
            <option value="thismonth" class="my_font">
              {{ $t("thismonth") }}
            </option>
            <option value="lastmonth" class="my_font">
              {{ $t("lastmonth") }}
            </option>
            <option value="lastyear" class="my_font">
              {{ $t("lastyear") }}
            </option>
            <option value="thisyear" class="my_font">
              {{ $t("thisyear") }}
            </option>
            <option value="all" class="my_font">{{ $t("all_time") }}</option>
          </select>
        </div>
        <div>
          <label
            class="block mb-2 text-sm text-textBlack1 dark:text-textWhite1"
          >
            {{ $t("debt_discount_type") }}
          </label>
          <select
            class="bg-white border border-gray-300 text-sm rounded-lg block w-full p-2 dark:bg-bgFullDark dark:border-gray-600 dark:text-white"
            v-model="ddType"
            @change="onFilterChanged"
          >
            <option value="">{{ $t("all") }}</option>
            <option value="0">{{ $t("debt_discount_loss") }}</option>
            <option value="1">{{ $t("debt_discount_gain") }}</option>
          </select>
        </div>
        <div>
          <label
            class="block mb-2 text-sm text-textBlack1 dark:text-textWhite1"
          >
            {{ $t("currency_type") }}
          </label>
          <select
            class="bg-white border border-gray-300 text-sm rounded-lg block w-full p-2 dark:bg-bgFullDark dark:border-gray-600 dark:text-white"
            v-model="curId"
            @change="onFilterChanged"
          >
            <option value="">{{ $t("all") }}</option>
            <option value="1">{{ $t("dinar") }}</option>
            <option value="2">{{ $t("dollar") }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Summary cards -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <div
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-2"
      >
        <ReportComponenet1Number
          :labelTxt="formatNumber(totals.total_loss_dinar)"
          :labelTitle="$t('total_debt_discount_loss_dinar')"
          :classColor="
            isDark ? ' from-red-500 ' : ' from-red-50 to-red-100 '
          "
        />
        <ReportComponenet1Number
          :labelTxt="formatNumber(totals.total_loss_dollar)"
          :labelTitle="$t('total_debt_discount_loss_dollar')"
          :classColor="
            isDark ? ' from-red-500 ' : ' from-red-50 to-red-100 '
          "
        />
        <ReportComponenet1Number
          :labelTxt="formatNumber(totals.total_gain_dinar)"
          :labelTitle="$t('total_debt_discount_gain_dinar')"
          :classColor="
            isDark ? ' from-green-500 ' : ' from-green-50 to-green-100 '
          "
        />
        <ReportComponenet1Number
          :labelTxt="formatNumber(totals.total_gain_dollar)"
          :labelTitle="$t('total_debt_discount_gain_dollar')"
          :classColor="
            isDark ? ' from-green-500 ' : ' from-green-50 to-green-100 '
          "
        />
      </div>
    </div>

    <!-- Table -->
    <div class="px-6 py-4">
      <div
        class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden"
      >
        <div
          class="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700 no-print"
        >
          <BaseInput
            :modelValue="search"
            @update:modelValue="handleSearchInput"
            :placeholder="$t('search')"
            :prefixIcon="'fa-solid fa-search'"
            class="w-40 md:w-full"
          />
        </div>

        <EasyDataTable
          v-model:server-options="serverOptions"
          :headers="headers"
          :items="items"
          :server-items-length="serverItemsLength"
          :loading="isLoadingData"
          :alternating="false"
          :buttons-pagination="true"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          :hide-footer="isHide"
          :rows-items="[25, 50, 100, serverItemsLength]"
          rows-per-page="25"
          :table-class-name="isDark ? 'modern-dark-table' : ''"
        >
          <template #default="{ column, sortDirection }">
            <div
              :class="`flex items-center space-x-2 ${
                $store.getters['isRtl'] ? 'justify-end' : 'justify-start'
              }`"
            >
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{
                column.label
              }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down"></i>
              </span>
            </div>
          </template>

          <template #item-dd_type="item">
            <span
              v-if="item.dd_type == 0"
              class="text-red-500 font-bold"
            >
              {{ $t("debt_discount_loss") }}
            </span>
            <span v-else class="text-green-600 font-bold">
              {{ $t("debt_discount_gain") }}
            </span>
          </template>

          <template #item-dd_amount="item">
            <span
              :class="
                item.dd_type == 0
                  ? 'text-red-500 font-bold'
                  : 'text-green-600 font-bold'
              "
            >
              {{ formatNumber(item.dd_amount) }}
            </span>
          </template>

          <template #item-customer_cu_name="item">
            <span v-if="item.customer">{{ item.customer.cu_name }}</span>
            <span v-else class="text-lg font-bold">__</span>
          </template>

          <template #item-suplier_su_name="item">
            <span v-if="item.suplier">{{ item.suplier.su_name }}</span>
            <span v-else class="text-lg font-bold">__</span>
          </template>

          <template #item-currency_cur_name="item">
            <span v-if="item.currency">{{ $t(item.currency.cur_name) }}</span>
          </template>

          <template #item-box_bo_name="item">
            <span v-if="item.box">{{ item.box.bo_name }}</span>
            <span v-else class="text-lg font-bold">__</span>
          </template>

          <template #item-debt_link="item">
            <a
              v-if="item.deb_id"
              :href="'/debt-detail/' + item.deb_id"
              target="_blank"
              class="text-blue-500 underline"
            >
              #{{ item.deb_id }}
            </a>
            <span v-else class="text-lg font-bold">__</span>
          </template>

          <template #item-dd_note="item">
            <span v-if="item.dd_note">{{ item.dd_note }}</span>
            <span v-else class="text-lg font-bold">__</span>
          </template>

          <template v-slot:[`item-users.name`]="item">
            <span v-if="item.users">{{ item.users.name }}</span>
            <span v-else class="text-lg font-bold">__</span>
          </template>

          <template #item-created_at="item">
            {{ formatDate(item.created_at) }}
          </template>

          <template #empty-message>
            <div class="flex flex-col items-center justify-center py-12">
              <i
                class="fa-solid fa-inbox text-4xl text-gray-400 dark:text-gray-600 mb-4"
              ></i>
              <p
                class="text-lg font-medium text-gray-700 dark:text-gray-300 mb-2"
              >
                {{ $t("no_data_found") }}
              </p>
            </div>
          </template>

          <template #loading>
            <div class="flex flex-col items-center justify-center py-8">
              <div
                class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"
              ></div>
              <p class="text-gray-500 dark:text-gray-400 text-sm">
                {{ $t("loading") }}...
              </p>
            </div>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { formatNumber, formatDate } from "../../utils/functions";
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import InvoiceHeader from "../../components/Navbar/InvoiceHeader.vue";
import ReportComponenet1Number from "../../components/Report/ReportComponenet1Number.vue";
import "../../assets/css/modern-table.css";

export default {
  name: "DebtDiscountReport",
  components: {
    HeaderApp,
    BaseInput,
    InvoiceHeader,
    ReportComponenet1Number,
  },
  data() {
    return {
      isHide: false,
      search: "",
      // Default to the start of the year through today so the page shows
      // something useful on first load.
      startDate: moment().startOf("year").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      period: "thisyear",
      ddType: "",
      curId: "",
      items: [],
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 25,
      },
      searchDebounceTimer: null,
    };
  },
  computed: {
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.debt_discount_report.isLoadingData;
    },
    totals() {
      return this.$store.state.debt_discount_report.totals;
    },
    headers() {
      return [
        { text: "#", value: "dd_id", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        { text: this.$t("debt_discount_type"), value: "dd_type", sortable: true },
        { text: this.$t("amount"), value: "dd_amount", sortable: true },
        {
          text: this.$t("currency_type"),
          value: "currency_cur_name",
          sortable: false,
        },
        {
          text: this.$t("customer"),
          value: "customer_cu_name",
          sortable: false,
        },
        {
          text: this.$t("suplier"),
          value: "suplier_su_name",
          sortable: false,
        },
        { text: this.$t("debt_box"), value: "box_bo_name", sortable: false },
        { text: this.$t("debt_id"), value: "debt_link", sortable: true },
        { text: this.$t("note"), value: "dd_note", sortable: false },
        { text: this.$t("admin"), value: "users.name", sortable: false },
      ];
    },
  },
  watch: {
    serverOptions: {
      handler() {
        this.loadFromServer();
      },
      deep: true,
    },
  },
  mounted() {
    if (
      this.$store.getters["checkUserAccess"]({ id: "26", action: "view" })
    ) {
      this.refreshAll();
    }
  },
  methods: {
    formatNumber(n) {
      return formatNumber(n || 0);
    },
    formatDate(d) {
      return formatDate(d);
    },
    buildFilters() {
      const payload = {
        search: this.search,
        startDate: this.startDate,
        endDate: this.endDate,
      };
      if (this.ddType !== "") payload.dd_type = this.ddType;
      if (this.curId !== "") payload.cur_id = this.curId;
      return payload;
    },
    onFilterChanged() {
      this.serverOptions.page = 1;
      this.refreshAll();
    },
    handleSearchInput(value) {
      this.search = value;
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.serverOptions.page = 1;
        this.refreshAll();
      }, 350);
    },
    onPeriodChanged() {
      const today = moment();
      switch (this.period) {
        case "today":
          this.startDate = today.format("YYYY-MM-DD");
          this.endDate = today.format("YYYY-MM-DD");
          break;
        case "yesterday":
          this.startDate = moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD");
          this.endDate = moment()
            .subtract(1, "days")
            .format("YYYY-MM-DD");
          break;
        case "last7days":
          this.startDate = moment()
            .subtract(7, "days")
            .format("YYYY-MM-DD");
          this.endDate = today.format("YYYY-MM-DD");
          break;
        case "last30days":
          this.startDate = moment()
            .subtract(30, "days")
            .format("YYYY-MM-DD");
          this.endDate = today.format("YYYY-MM-DD");
          break;
        case "thismonth":
          this.startDate = moment().startOf("month").format("YYYY-MM-DD");
          this.endDate = moment().endOf("month").format("YYYY-MM-DD");
          break;
        case "lastmonth":
          this.startDate = moment()
            .subtract(1, "months")
            .startOf("month")
            .format("YYYY-MM-DD");
          this.endDate = moment()
            .subtract(1, "months")
            .endOf("month")
            .format("YYYY-MM-DD");
          break;
        case "lastyear":
          this.startDate = moment()
            .subtract(1, "years")
            .startOf("year")
            .format("YYYY-MM-DD");
          this.endDate = moment()
            .subtract(1, "years")
            .endOf("year")
            .format("YYYY-MM-DD");
          break;
        case "thisyear":
          this.startDate = moment().startOf("year").format("YYYY-MM-DD");
          this.endDate = moment().endOf("year").format("YYYY-MM-DD");
          break;
        case "all":
          this.startDate = "2000-01-01";
          this.endDate = moment().endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.onFilterChanged();
    },
    refreshAll() {
      this.loadFromServer();
      this.loadTotals();
    },
    async loadFromServer() {
      const payload = {
        ...this.buildFilters(),
        page: this.serverOptions.page,
        rowsPerPage: this.serverOptions.rowsPerPage,
        sortBy: this.serverOptions.sortBy,
        sortType: this.serverOptions.sortType,
      };
      const res = await this.$store.dispatch(
        "debt_discount_report/getItems",
        payload
      );
      if (res && res.data) {
        this.items = res.data.data || [];
        this.serverItemsLength = res.data.total || 0;
      } else {
        this.items = [];
        this.serverItemsLength = 0;
      }
    },
    async loadTotals() {
      await this.$store.dispatch(
        "debt_discount_report/getTotals",
        this.buildFilters()
      );
    },
    async printReportFunc() {
      this.isHide = true;
      // wait for layout, then print
      setTimeout(() => {
        window.print();
        this.isHide = false;
      }, 250);
    },
  },
};
</script>
